<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-12">
        <div class="row">
          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [required]="true" [onlyConfigured]="true"></app-company-selector>
          </div>
          <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear" [required]="true">
            </app-year-selector>
          </div>
          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany"
              (click)="onSearch()">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <dx-data-grid #gridPersonas [dataSource]="holidays" [allowColumnResizing]="true"
      [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)">
      <dxo-selection [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'" mode="multiple"></dxo-selection>

      <!-- Definición de las columnas -->
      <dxi-column caption="Centro" alignment="center">
        <dxi-column dataField="CodigoCentro" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="DescripcionCentro" caption="Centro"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Imputación" alignment="center">
        <dxi-column dataField="CodigoImputacion" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="DescripcionImputacion" caption="Imputacion"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Trabajador" alignment="center">
        <dxi-column dataField="CodigoTrabajador" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="NombreTrabajador" caption="Trabajador"> </dxi-column>
      </dxi-column>

      <dxi-column caption="Días Tramitados" alignment="center">
        <dxi-column dataField="Suma" caption="Total" alignment="center" [width]="110"></dxi-column>
        <!-- <dxi-column dataField="DiasPeridosPasadoEjercicio" caption="Perdidos año anterior" alignment="center"></dxi-column> -->
        <dxi-column dataField="Realizados" caption="Realizados"></dxi-column>
        <!-- <dxi-column dataField="Autorizados" caption="Autorizados"></dxi-column> -->
        <dxi-column dataField="Solicitados" caption="Solicitados"></dxi-column>
        <dxi-column dataField="DiasReales" caption="Reales" alignment="center" ></dxi-column>
        <dxi-column caption="Riesgo" [calculateDisplayValue]="getRiesgo" alignment="center" ></dxi-column>
      </dxi-column>
      <dxo-export [enabled]="true"></dxo-export>

    </dx-data-grid>

  </app-generic-panel>
  <br>
</app-generic-container>
